export default __webpack_public_path__ + "static/media/meetingsvg.067197a9.svg";